// extracted by mini-css-extract-plugin
module.exports = {"tabs":"RoundTabBar_tabs__IStzM"};